class Calcs {
	constructor() {
        this.calulate();

        document.addEventListener('DOMContentLoaded', e => {
            this.calulate();
        });

        // We listen to the resize event
        window.addEventListener('load', () => {
            this.calulate();
        });

        // We listen to the resize event
        window.addEventListener('resize', () => {
            this.calulate();
        });
	}
    calulate() {
        const header = document.querySelector('.mn-hdr');
        const container = document.querySelector('.container');
        const jdlBtn = document.querySelector('.jdl-btn');
        const jdlContent = document.querySelector('.jdl-content');

        /* View height */
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh.toFixed(2)}px`);

        /* Header height */
        if (header) {
            // Get the header element height
            let hh = header.offsetHeight;
            // Then we set the value in the --hh custom property to the root of the document
            document.documentElement.style.setProperty('--hh', `${hh}px`);
        }

        /* JDL Button */
        if (jdlBtn) {
            // Get the header element height
            let jdlBtnH = jdlBtn.offsetHeight;
            // Then we set the value in the --jdlBtn custom property to the root of the document
            document.documentElement.style.setProperty('--jdlBtn', `${jdlBtnH}px`);
        }

        /* JDL content height */
        if (jdlContent) {
            // Get the header element height
            let jdlH = jdlContent.offsetHeight;
            // Then we set the value in the --jdl custom property to the root of the document
            document.documentElement.style.setProperty('--jdl', `${jdlH+1}px`);

            // Show element - Remove style attr
            document.addEventListener('DOMContentLoaded', e => {
                setTimeout(() => {
                    jdlContent.removeAttribute('style');
                }, 1000);
            });
        }

        if (container) {
            // Get the computed max-width of the element (returns a string like '1200px')
            const containerMaxWidth = parseFloat(getComputedStyle(container).maxWidth);
            // Get the current window width
            const windowWidth = window.innerWidth;
            // Calculate any extra space beyond the element's max width
            const extraSpace = windowWidth > containerMaxWidth ? (windowWidth - containerMaxWidth) / 2 : 0;

            // Then we set the value in the --hh custom property to the root of the document
            document.documentElement.style.setProperty('--es', `${extraSpace}px`);
        }
    }
}

export default new Calcs();
